$(document).ready ->
  $('#user_i9form_user_id').change ->
    optionSelected = $("option:selected", this);
    $("#user_first_day").val(optionSelected.data('first-day'));
    return
    
  $('#user_i9form_i9form_employer_id').change ->
    $.ajax
      method: 'GET'
      url: "#{$(this).data('url')}.json"
      dataType: 'json',
      data: 'i9form_employer_id': $(this).val()
      success: (data) ->
        listitems = []
        $.each data, (key, value) ->
          listitems += '<option value="' + value.Id + '">' + value.Name + '</option>'
          return
        $("#user_i9form_worksite_id").html(listitems);
        $("#user_i9form_worksite_id").trigger("chosen:updated");
        return
      error: (result) ->
        return
    return